import { ResetPasswordTemplate } from '@/templates'

const ResetPassword = (): JSX.Element => {
  return <ResetPasswordTemplate />
}

export default ResetPassword
